import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-smash-back-btn',
  templateUrl: './smash-back-btn.component.html',
  styleUrls: ['./smash-back-btn.component.scss']
})
export class SmashBackBtnComponent {

  @Output() goBack: EventEmitter<any> = new EventEmitter<any>();
  
  constructor() { }

  onClick() {
    this.goBack.emit(true);
  }

}
